export default {"src":"/_next/static/media/ASAN.7e8ad55c.svg","height":18,"width":18};